// Mock data for the application
// User data
export interface User {
  id: string
  name: string
  email: string
  avatar: string
  role: 'student' | 'teacher'
  points: number
  badges: string[]
}
export const currentUser: User = {
  id: 'user1',
  name: '李大明',
  email: 'liming@example.com',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  role: 'student',
  points: 450,
  badges: ['beginner', 'consistent', 'streak7'],
}
// Update user function
export const updateCurrentUser = (userData: Partial<User>) => {
  Object.assign(currentUser, userData)
  return currentUser
}
// Learning goal data
export interface Goal {
  id: string
  studentId: string
  studentName: string
  title: string
  description: string
  deadline: string
  status: 'pending' | 'submitted' | 'approved' | 'rejected'
  createdAt: string
}
export const studentGoals: Goal[] = [
  {
    id: 'goal1',
    studentId: 'user1',
    studentName: '李明',
    title: '一周内完成两篇雅思作文练习',
    description: '完成两篇不同题目的雅思大作文，每篇不少于250词',
    deadline: '2023-11-15',
    status: 'pending',
    createdAt: '2023-11-01',
  },
  {
    id: 'goal2',
    studentId: 'user1',
    studentName: '李明',
    title: '背诵50个高频雅思词汇',
    description: '从雅思词汇书中选择50个高频词汇进行背诵和造句',
    deadline: '2023-11-10',
    status: 'submitted',
    createdAt: '2023-11-02',
  },
  {
    id: 'goal3',
    studentId: 'user2',
    studentName: '张伟',
    title: '完成数学练习册第三章',
    description: '完成高等数学练习册第三章的所有习题',
    deadline: '2023-11-20',
    status: 'approved',
    createdAt: '2023-11-05',
  },
]
// Completion submission data
export interface Submission {
  id: string
  goalId: string
  studentId: string
  studentName: string
  content: string
  evidence: string
  submittedAt: string
  status: 'pending' | 'approved' | 'rejected'
  feedback?: string
  pointsAwarded?: number
}
export const submissions: Submission[] = [
  {
    id: 'sub1',
    goalId: 'goal2',
    studentId: 'user1',
    studentName: '李明',
    content: '我已完成50个雅思词汇的背诵和造句，请查看附件',
    evidence:
      'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c3R1ZHl8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60',
    submittedAt: '2023-11-08',
    status: 'pending',
  },
  {
    id: 'sub2',
    goalId: 'goal3',
    studentId: 'user2',
    studentName: '张伟',
    content: '已完成数学练习册第三章的所有习题，包括附加题',
    evidence:
      'https://images.unsplash.com/photo-1532094349884-543bc11b234d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cGh5c2ljc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60',
    submittedAt: '2023-11-15',
    status: 'approved',
    feedback: '做得很好，所有题目都正确解答',
    pointsAwarded: 50,
  },
]
// Badge data
export interface Badge {
  id: string
  name: string
  description: string
  icon: string
  pointsValue: number
}
export const badges: Badge[] = [
  {
    id: 'beginner',
    name: '学习起步',
    description: '完成第一个学习目标',
    icon: '🌱',
    pointsValue: 50,
  },
  {
    id: 'consistent',
    name: '坚持不懈',
    description: '连续完成3个学习目标',
    icon: '🔥',
    pointsValue: 70,
  },
  {
    id: 'streak7',
    name: '优秀表现',
    description: '获得教师的高度评价',
    icon: '🏆',
    pointsValue: 100,
  },
  {
    id: 'master',
    name: '学科大师',
    description: '在同一学科完成5个学习目标',
    icon: '📚',
    pointsValue: 150,
  },
]
